import { useRouter } from '@core/utils/utils'

export default [
  {
    title: 'صورت جلسات',
    icon: 'MailIcon',
    children: [
      {
        title: 'صورتجلسات من',
        icon: 'InboxIcon',
        route: 'Agendas_Inbox',
        permission: 'agendas.inbox',
      },
      {
        title: 'صورتجلسات ثبت شده',
        icon: 'SendIcon',
        route: 'Agendas_Sent',
        permission: 'agendas.index',
      },
      {
        title: 'صورتجلسه جدید',
        icon: 'Edit3Icon',
        route: 'Agendas_Create',
        permission: 'agendas.store',
      },
    ],
  },
]
